import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { apiInstance } from '../../axiosApi';

export const brandingListGet = createAsyncThunk('admin/company-branding', async (params) => {
  return await apiInstance.get('/company-branding', { params });
});

export const brandingDelete = createAsyncThunk('admin/company-branding-delete', async (id) => {
  return await apiInstance.delete(`/company-branding/${id}`);
});

export const brandingAdd = createAsyncThunk('admin/company-branding-add', async (payload) => {
  return await apiInstance.post('/company-branding', payload);
});

export const brandingUpdate = createAsyncThunk('admin/company-branding-update', async (payload) => {
  const { id, formData } = payload;
  return await apiInstance.put(`/company-branding/${id}`, formData);
});

const initialState = {
  brandingList: null
};

const brandingSlice = createSlice({
  name: 'branding',
  initialState,
  reducers: {
    clearBrandingSlice: () => initialState
  },
  extraReducers: (builder) => {
    builder.addCase(brandingListGet.fulfilled, (state, action) => {
      state.brandingList = action?.payload;
    });
  }
});

export default brandingSlice.reducer;
export const { clearBrandingSlice } = brandingSlice.actions;

export const selectBrandingList = (state) => state.branding.brandingList;
export const useBrandingList = () => {
  const brandingList = useSelector(selectBrandingList);
  return useMemo(() => brandingList, [brandingList]);
};
